import { EventEmitter } from '@angular/core';
import { SortDirection } from '@angular/material/sort';

export class SortModel {
  constructor() {
    this._key = '';
    this._direction = '';
    this._propertyChange = new EventEmitter<{ key: string; value: string | SortDirection }>();
  }

  private _propertyChange: EventEmitter<{ key: string; value: string | SortDirection }>;

  get propertyChange(): EventEmitter<{ key: string; value: string | SortDirection }> {
    return this._propertyChange;
  }

  private _key: string;

  get key(): string {
    return this._key;
  }

  set key(value: string) {
    this._key = value;
    this.propertyChange.emit({
      key: 'key',
      value: value,
    });
  }

  private _direction: SortDirection;

  get direction(): SortDirection {
    return this._direction;
  }

  set direction(value: SortDirection) {
    this._direction = value;
    this.propertyChange.emit({
      key: 'direction',
      value: value,
    });
  }

  mapToQueryString(): string {
    const params: string[] = [];

    if (this._key && this._direction) {
      params.push(`sort=${encodeURIComponent(this._key)}.${encodeURIComponent(this._direction)}`);
    }

    return params.join('&');
  }
}
